<template>
  <div class="font-montserrat">
    <h2>Announcements</h2>
    <!-- Current/Last Announcement -->
    <div class="card py-2 mb-4">
      <div
        class="card-body d-flex flex-row justify-content-between align-items-center"
      >
        <span class="fs-5 px-4 fw-bold">
          {{
            announcements.length
              ? announcements[0].text
              : "No announcements yet."
          }}
        </span>
        <button
          v-if="announcements.length"
          class="btn shadow-sm btn-primary text-nowrap"
          @click.prevent="handleRepostAnnouncement(announcements[0])"
        >
          Re-Post
        </button>
      </div>
      <div v-if="announcements.length" class="px-4 text-muted small">
        Posted at: {{ formatDate(announcements[0].date) }}
      </div>
    </div>

    <!-- Generate New Announcement -->
    <div class="py-4 d-flex flex-row align-items-center gap-3">
      <div class="d-flex flex-column gap-2 align-items-center">
        <span class="fs-6">Generate Announcement:</span>
        <textarea
          v-model="newAnnouncement"
          name="announcement"
          id="announce"
          style="max-width: 400px; min-width: 100px; width: 400px"
        ></textarea>
      </div>
      <button
        class="btn shadow-sm btn-success text-nowrap"
        @click.prevent="handleGenerateAnnouncement"
      >
        Generate
      </button>
    </div>

    <!-- List All Announcements -->
    <div
      class="d-flex flex-column align-items-center justify-content-start border"
      style="min-height: 200px; width: 100%"
    >
      <h5 class="mt-3">All Announcements</h5>
      <table class="table w-75 mt-2">
        <thead>
          <tr>
            <th>#</th>
            <th>Announcement</th>
            <th>Date</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(a, idx) in announcements" :key="a.id">
            <td>{{ idx + 1 }}</td>
            <td>{{ a.text }}</td>
            <td>{{ formatDate(a.date) }}</td>
          </tr>
          <tr v-if="!announcements.length">
            <td colspan="3" class="text-center text-muted">
              No announcements found.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";

const newAnnouncement = ref("");
const announcements = ref([
  {
    id: 1,
    text: "Welcome to the new platform!",
    date: new Date(),
  },
]);

function handleGenerateAnnouncement() {
  if (!newAnnouncement.value.trim()) {
    alert("Please enter an announcement.");
    return;
  }
  announcements.value.unshift({
    id: Date.now(),
    text: newAnnouncement.value,
    date: new Date(),
  });
  alert("Announcement generated!");
  newAnnouncement.value = "";
}

function handleRepostAnnouncement(announcement) {
  alert("Reposting announcement:\n" + announcement.text);
}

function formatDate(date) {
  if (!date) return "";
  const d = new Date(date);
  return d.toLocaleString();
}
</script>

<style scoped>
.font-montserrat {
  font-family: "Montserrat", Arial, sans-serif;
}
.border {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
}
</style>
